module.exports = __webpack_public_path__ + "img/000.3a2c41eb.png";